import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DailyForecast, iconConfig } from '../../models/weather.model';

@Component({
  selector: 'dr-flex-home-ui-day-tile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './day-tile.component.html',
  styleUrls: ['./day-tile.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DayTileComponent {
  day = input.required<DailyForecast>();
  label = input(''); 
  unit = input< 'C' | 'F'>('C');
  active = input(false);

  iconConfig(summary: number | null) {
    return iconConfig(summary);
  }

  get max(): number {
    return this.day().maxTemperature;
  }
  get min(): number {
    return this.day().minTemperature;
  }
}
